/* KOR-E cart upsell — extracted from snippets/cart-drawer.liquid (Batch AQ). Liquid-free.
   Rendered on every page (drawer is global), so 5.4KB of inline script left every document. */

        /* KOR-E Cart Upsell v6 — two-step: POST add → GET section refresh (mirrors Dawn's onCartUpdate) */
        if (!window.koreUpsellReady) {
          window.koreUpsellReady = true;
          document.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-kore-upsell-id]');
            if (!btn || btn.disabled) return;
            var variantId = parseInt(btn.getAttribute('data-kore-upsell-id'), 10);
            if (!variantId) return;

            btn.disabled = true;
            btn.textContent = '...';

            /* Step 1: Add item to cart */
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(function(r) {
              if (!r.ok) throw new Error('cart-add-failed');
              return r.json();
            })
            .then(function() {
              /* Step 2: Refresh cart drawer — same approach as Dawn's CartItems.onCartUpdate() */
              var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
              return fetch(cartUrl + '?section_id=cart-drawer')
                .then(function(r) { return r.text(); })
                .then(function(html) {
                  var doc = new DOMParser().parseFromString(html, 'text/html');

                  /* Replace <cart-drawer-items> — contains cart items + upsell strip */
                  var newItems = doc.querySelector('cart-drawer-items');
                  var curItems = document.querySelector('cart-drawer-items');
                  if (curItems && newItems) curItems.replaceWith(newItems);

                  /* Replace cart subtotal footer (totals row) */
                  var newFooter = doc.querySelector('.cart-drawer__footer');
                  var curFooter = document.querySelector('.cart-drawer__footer');
                  if (curFooter && newFooter) curFooter.replaceWith(newFooter);

                  /* Sync is-empty class on <cart-drawer> and checkout button disabled state */
                  var newCd = doc.querySelector('cart-drawer');
                  var curCd = document.querySelector('cart-drawer');
                  if (curCd && newCd) {
                    var isEmpty = newCd.classList.contains('is-empty');
                    curCd.classList.toggle('is-empty', isEmpty);
                    var checkoutBtn = document.getElementById('CartDrawer-Checkout');
                    if (checkoutBtn) checkoutBtn.disabled = isEmpty;

                    /* When going from empty to non-empty, remove the stale empty-state overlay.
                       drawer__inner-empty has height:100% so it occupies the full drawer
                       height even after is-empty is removed from cart-drawer. */
                    if (!isEmpty) {
                      var emptyOverlay = document.querySelector('#CartDrawer .drawer__inner-empty');
                      if (emptyOverlay) emptyOverlay.remove();
                    }
                  }

                  /* Step 3: Update header cart icon bubble count */
                  fetch(cartUrl + '?section_id=cart-icon-bubble')
                    .then(function(r) { return r.text(); })
                    .then(function(iconHtml) {
                      var iconDoc = new DOMParser().parseFromString(iconHtml, 'text/html');
                      var newBubble = iconDoc.querySelector('.shopify-section');
                      var iconEl = document.getElementById('cart-icon-bubble');
                      if (newBubble && iconEl) iconEl.innerHTML = newBubble.innerHTML;
                    })
                    .catch(function() {});
                });
            })
            .catch(function() {
              /* Restore button on any failure at any step */
              var failBtn = document.querySelector('[data-kore-upsell-id="' + variantId + '"]');
              if (failBtn) { failBtn.disabled = false; failBtn.textContent = 'הוסף'; }
            });
          });
        }

        /* KOR-E Upsell card navigation — click anywhere on card → product page, except Add button */
        if (!window.koreUpsellNavReady) {
          window.koreUpsellNavReady = true;

          document.addEventListener('click', function(e) {
            var card = e.target.closest('.kore-upsell-strip__card');
            if (!card) return;
            /* If the click was on/inside the Add button, let the cart handler take it */
            if (e.target.closest('[data-kore-upsell-id]')) return;
            var url = card.getAttribute('data-product-url');
            if (!url) return;
            window.location.href = url;
          });

          /* Keyboard: Enter or Space activates the card as a link */
          document.addEventListener('keydown', function(e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            var card = document.activeElement && document.activeElement.closest('.kore-upsell-strip__card');
            if (!card) return;
            if (document.activeElement.closest('[data-kore-upsell-id]')) return;
            e.preventDefault();
            var url = card.getAttribute('data-product-url');
            if (!url) return;
            window.location.href = url;
          });
        }
